import { Modal, Paper, Typography, Grid, TextField, MenuItem, FormControlLabel, Switch, Button, Fade, CircularProgress } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { Alert as MaterialAlert } from '@material-ui/lab';
import { DateTimePicker } from '@material-ui/pickers';
import Alert from 'components/Alert';
import CustomMaskedInput from 'components/MaskedInput/index';
import { theme } from 'components/Theme';
import { functions } from 'helpers';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { createCouponsBatch } from 'store/Orbita/Product/actions';

import type { DispatchProp } from 'react-redux';

const styles = withStyles(() => ({
  file_input: {
    fontSize: 14,
    fontWeight: 500,
    background: '#DDD',
    width: '100%',
    height: 36,
    padding: '6px 16px',
    textAlign: 'center',
    borderRadius: 4,
    '&:hover': {
      margin: '10px solid #000',
      boxShadow: '1px 2px 5px 0px rgba(0,0,0,0.43)',
    },
  },
}));
interface ICoupon {
  key: string;
  description: string;
  type: 'P' | 'V';
  value: string;
  quantity: string;
  limeted_date: Date;
  hasLimitDate: boolean;
  hasLimitQuantity: boolean;
}

interface IProps extends DispatchProp<any>, StyledComponentProps {
  open: boolean;
  handleClose: any;
  product: any;
  update: any;
  coproducers: any;
  user: any;
}

interface IStates {
  coupon: ICoupon;
  submitting: boolean;
  openUploadModal: boolean;
  fileUploaded: any;
  alert: boolean;
}

class CouponBatchForm extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      coupon: {
        key: '',
        description: '',
        type: 'P',
        value: '0',
        quantity: '0',
        limeted_date: new Date(),
        hasLimitDate: false,
        hasLimitQuantity: false,
      },
      submitting: false,
      openUploadModal: false,
      fileUploaded: false,
      alert: false,
    };
  }

  handleChange = (
    name: 'key' | 'description' | 'type' | 'value' | 'hasLimitQuantity' | 'hasLimitDate' | 'quantity' | 'never' | 'limeted_date',
    value: any
  ) => {
    const coupon: ICoupon = this.state.coupon;
    if (name === 'type') {
      coupon['value'] = '0';
    }
    coupon[name] = value;

    const shouldShowAlert = coupon['type'] === 'P' && Number.parseFloat(functions.clearMoneyMask(coupon['value'])) > 95;

    this.setState({ alert: shouldShowAlert });
    this.setState({ coupon });
  };

  addFile = (event: any) => {
    this.setState({ fileUploaded: event.target.files[0] });
  };

  handleSubmit = async () => {
    const couponSubmit = {};
    const { coupon } = this.state;

    if (coupon.description === '') {
      toast.warn('Preencha a descrição do cupom');
      return;
    }

    if (Number.parseFloat(functions.clearMoneyMask(coupon.value)) <= 0) {
      toast.warn('Preencha o valor do cupom');
      return;
    }

    if (!this.state.fileUploaded) {
      toast.warn('Selecione um arquivo para continuar');
      return;
    }

    if (coupon.type === 'P' && Number.parseFloat(functions.clearMoneyMask(coupon.value)) === 100) {
      toast.warn('Não é permitido criar um cupom com 100% de desconto');
      return;
    }

    const confirmation = await Alert.show({
      title: 'Atenção',
      message:
        'Verifique se seus afiliados e coprodutores possuem uma comissão maior que o valor do produto com cupom de desconto. Nesses casos a comissão será afetada.',
      confirmation: true,
      buttonOk: 'Criar cupons',
      buttonCancel: 'Cancelar',
    });

    if (!confirmation) {
      return;
    }

    if (coupon.hasLimitDate) {
      couponSubmit['limeted_date'] = moment(coupon.limeted_date).format('Y-M-D H:m');
    }

    couponSubmit['quantity'] = 0;

    if (coupon.hasLimitQuantity) {
      couponSubmit['quantity'] = Number.parseFloat(coupon.quantity);
    }

    couponSubmit['value'] = Number.parseFloat(functions.clearMoneyMask(coupon.value));

    couponSubmit['description'] = coupon.description;
    couponSubmit['type'] = coupon.type;

    let product = this.props.product;

    (async () => {
      try {
        this.setState({ submitting: true });
        await this.props.dispatch(createCouponsBatch(this.state.fileUploaded, couponSubmit, product));
        toast.success('Lote de cupons criado com sucesso');
        this.setState({ submitting: false });
        this.props.handleClose();
        this.props.update(null, 2);
      } catch (error) {
        toast.error(error);
        this.setState({ submitting: false });
      }
    })();
  };

  handleOpenUploadModal = () => {
    this.setState({ openUploadModal: !this.state.openUploadModal });
  };

  render() {
    const coupon: ICoupon = this.state.coupon;
    const { classes } = this.props;

    const warning = () => {
      if (this.state.alert) {
        return (
          <>
            <Fade in={true}>
              <Typography style={{ color: 'red' }} component='p'>
                <small>Atenção! Seus ganhos podem ficar negativados com o desconto configurado.</small>
              </Typography>
            </Fade>
            <div className='m32' />
          </>
        );
      }
      return null;
    };

    return (
      <MuiThemeProvider theme={theme}>
        <Modal
          open={this.props.open}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClose={this.props.handleClose}
        >
          <Paper
            elevation={10}
            style={{
              maxHeight: '99vh',
              borderRadius: 4,
              padding: '1.5rem',
              overflow: 'auto',
              width: '50vw',
              maxWidth: 620,
            }}
          >
            <Typography variant='h6' style={{ color: '#192542' }}>
              Novo Lote
            </Typography>
            <div className='m32' />
            <div>Preencha os campos abaixo para configurar seu lote de cupons</div>
            <div className='m32' />
            {warning()}
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <TextField
                  value={coupon.description}
                  onChange={(e: any) => this.handleChange('description', e.target.value)}
                  fullWidth
                  helperText='Ex.: Cupom promocional'
                  label='Descrição'
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id='type'
                  label='Tipo'
                  select
                  fullWidth
                  InputProps={{
                    disableUnderline: true,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={coupon.type}
                  onChange={(e: any) => this.handleChange('type', e.target.value)}
                >
                  <MenuItem value='P'>Porcentagem</MenuItem>
                  <MenuItem value='V'>Valor</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                {coupon.type === 'P' && (
                  <CustomMaskedInput
                    mask='percent'
                    label='Valor'
                    startAdornment='%'
                    fullWidth={true}
                    disableUnderline={true}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={coupon.value}
                    onChange={(value: any) => this.handleChange('value', value)}
                  />
                )}
                {coupon.type === 'V' && (
                  <CustomMaskedInput
                    mask='money'
                    label='Valor'
                    startAdornment='R$'
                    disableUnderline={true}
                    fullWidth={true}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={coupon.value}
                    onChange={(value: any) => this.handleChange('value', value)}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  label='Data de validade (opcional)'
                  control={
                    <Switch
                      color='default'
                      checked={coupon.hasLimitDate}
                      onChange={(e: any) => this.handleChange('hasLimitDate', e.target.checked)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  label='Limite de uso(opcional)'
                  control={
                    <Switch
                      color='default'
                      checked={coupon.hasLimitQuantity}
                      onChange={(e: any) => this.handleChange('hasLimitQuantity', e.target.checked)}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Fade in={coupon.hasLimitDate} timeout={500}>
                  <DateTimePicker
                    id='limeted_date'
                    label='Data'
                    variant='inline'
                    format='dd/MM/yyyy HH:mm'
                    disableToolbar
                    disablePast
                    minDate={new Date()}
                    ampm={false}
                    fullWidth
                    value={coupon.limeted_date}
                    onChange={(value: any) => this.handleChange('limeted_date', value)}
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Fade>
              </Grid>
              <Grid item xs={12} md={6}>
                <Fade in={coupon.hasLimitQuantity} timeout={500}>
                  <div>
                    <CustomMaskedInput
                      mask='number'
                      label='Quantidade'
                      fullWidth={true}
                      disableUnderline={true}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={coupon.quantity}
                      onChange={(value: any) => this.handleChange('quantity', value)}
                    />
                  </div>
                </Fade>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <input accept='.csv' id='contained-button-file' type='file' style={{ display: 'none' }} onChange={this.addFile} />
                <label htmlFor='contained-button-file' className={classes.file_input}>
                  {this.state.fileUploaded && this.state.fileUploaded.name ? (
                    <span style={{ marginTop: 10 }}>
                      <small>Arquivo: {this.state.fileUploaded.name}</small>
                    </span>
                  ) : (
                    'SELECIONAR UM ARQUIVO'
                  )}
                </label>
              </Grid>
              <Grid item xs={12} md={12}>
                <MaterialAlert severity='info'>
                  <small>
                    <p>Cada arquivo deve ter 1 código alfanumérico por linha (limite de 14 caracteres por linha).</p>
                    <p>Não serão permitidos caracteres especiais. Formato: .csv Tamanho máx: 10 mb por arquivo.</p>
                    <p>
                      <a target='_blank' rel='noopener noreferrer' href='https://eduzz-public-files.s3.amazonaws.com/example.csv'>
                        Veja um exemplo
                      </a>
                    </p>
                  </small>
                </MaterialAlert>
              </Grid>
              <div className='m16' />
              <Grid container justify='flex-end'>
                <Button color='default' disabled={this.state.submitting} onClick={this.props.handleClose}>
                  Fechar
                </Button>
                <Button color='secondary' variant='contained' disabled={this.state.submitting} onClick={this.handleSubmit}>
                  Salvar
                  {this.state.submitting && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Modal>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    coproducers: state.orbita.Product.coProducers,
    user: state.orbita.User.user,
  };
}

export default connect(mapStateToProps)(styles(CouponBatchForm));
